import type { SnippetsProvider } from '@atlassian/editor-snippets-provider/types';

import { getSnippetsStateSnapshot, onCurrentFetchComplete } from '../store/snippetsStore.ts';
import type { Snippet as ConfluenceSnippet } from '../types/snippet.ts';

import { mapConfluenceSnippet } from './mapConfluenceSnippet.ts';

const getConfluenceSnippets = (): Promise<ConfluenceSnippet[]> => {
	const { snippets, isLoaded, fetchError } = getSnippetsStateSnapshot();

	if (isLoaded) {
		return Promise.resolve(snippets);
	}

	if (fetchError) {
		return Promise.resolve([]);
	}

	return new Promise((resolve) => {
		onCurrentFetchComplete((loadedSnippets) => {
			resolve(loadedSnippets);
		});
	});
};

export const createConfluenceSnippetsProvider = (
	getUserId: () => string | undefined = () => undefined,
): SnippetsProvider => ({
	getSnippets: async () => {
		const snippets = await getConfluenceSnippets();
		const userId = getUserId();
		return snippets.map((snippet) => ({
			...mapConfluenceSnippet(snippet),
			...(userId && { isCreatedByCurrentUser: snippet.createdBy?.accountId === userId }),
		}));
	},
});

export const confluenceSnippetsProvider: SnippetsProvider = createConfluenceSnippetsProvider();
